import styled from "styled-components";

const ScrollToTop = styled.button`
  position: fixed;
  bottom: 0;
  right: 0;
  width: 64px;
  height: 70px;
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  background-color: ${({theme}) => theme.colors.highlight};
  outline: none;
  animation: fadeIn 1s;
  transition: opacity 1s;
  border-radius: 100px 0 0 0;

  &:focus,
  &:hover {
    .scroll-to__icon {
      fill: ${({theme}) => theme.colors.black};
      transform: scale(1.1);
    }
  }

  &.is-hidden {
    display: none;
  }

  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }

  .scroll-to__icon {
    margin-bottom: 12px;
    margin-right: 10px;
    width: 30px;
    height: 30px;
    fill: ${({theme}) => theme.colors.black};
  }
`;

export default ScrollToTop;